'use client';

export default function HeroSection() {
  return (
    <section className="courtroom-hero">
      <div className="hero-overlay" />
      <div className="site-container hero-content">
        <p className="hero-eyebrow">Established 2003 — New York City, New York</p>
        <h1>
          <span>Precision Counsel.</span>
          <em>Powerful Results.</em>
        </h1>
        <p className="hero-lede">
          For over two decades, Harrington & Associates LLP has delivered strategic legal representation to individuals, entrepreneurs, and corporations across New York and the tri-state area.
        </p>
        <div className="hero-actions">
          <a className="button button-gold" href="#contact">
            Schedule Consultation
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M7 7h10v10" />
              <path d="M7 17 17 7" />
            </svg>
          </a>
          <a className="button button-outline-light" href="#practice-areas">
            Our Practice Areas
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
      <div className="hero-scroll">
        <span>Scroll to explore</span>
        <i />
      </div>
    </section>
  );
}
